"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
const enums_1 = require("../enums");
class IncentiveSettlement extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(Object.values(enums_1.ProductType)),
    (0, base_models_1.Docs)({ example: enums_1.ProductType.ELECTRICITY, description: 'Product type the incentive is for' }),
    tslib_1.__metadata("design:type", String)
], IncentiveSettlement.prototype, "productType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(enums_1.SettlementType)),
    (0, base_models_1.Docs)({ example: enums_1.SettlementType.CASHBACK, description: 'Type of settlement for the incentive' }),
    tslib_1.__metadata("design:type", String)
], IncentiveSettlement.prototype, "type", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(enums_1.SettlementMoment)),
    (0, base_models_1.Docs)({ example: enums_1.SettlementMoment.COOLDOWN_END, description: 'When the settlement for the incentive activates' }),
    tslib_1.__metadata("design:type", String)
], IncentiveSettlement.prototype, "moment", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(0),
    (0, base_models_1.Docs)({ example: 3, description: 'Offset from when the settlement activates' }),
    tslib_1.__metadata("design:type", Number)
], IncentiveSettlement.prototype, "momentOffset", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(enums_1.OffsetUnit)),
    (0, base_models_1.Docs)({ example: enums_1.OffsetUnit.MONTHS, description: 'Unit of the offset for the settlement activation' }),
    tslib_1.__metadata("design:type", String)
], IncentiveSettlement.prototype, "momentOffsetUnit", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: 'supplier_id', description: 'ID of the supplier' }),
    tslib_1.__metadata("design:type", String)
], IncentiveSettlement.prototype, "supplierId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.Docs)({ example: 80, description: 'Incentive settlement value' }),
    tslib_1.__metadata("design:type", Number)
], IncentiveSettlement.prototype, "value", void 0);
exports.default = IncentiveSettlement;
